// src/components/Layout.tsx
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Outlet } from 'react-router-dom';
import useScrollToHash from '@/hooks/useScrollToHash';
import TitleHandler from '@/components/TitleHandler';
import GoogleTagManager from '@/components/GoogleTagManager';

const Layout = () => {
  // Use our custom hook to handle hash navigation
  useScrollToHash();

  return (
    <div className="flex flex-col min-h-screen">
      {/* TitleHandler sets document title based on current route */}
      <TitleHandler />
      <GoogleTagManager />
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
